module.exports = __webpack_public_path__ + "static/media/landscape_eye.35efc748.jpg";